import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private defaultersLength = new BehaviorSubject(0);
  private trainerDefaultersLength = new BehaviorSubject(0);
  private refreshDefaulters = new BehaviorSubject("");
  currentLength = this.defaultersLength.asObservable();
  currentTrainerLength = this.trainerDefaultersLength.asObservable();
  currentRefreshDefaulters = this.refreshDefaulters.asObservable();

  constructor() { }

  changeLength(length: number) {
    this.defaultersLength.next(length)
  }
  changeTrainerLength(length: number) {
    this.trainerDefaultersLength.next(length)
  }
  refreshDefaulter(value: string) {
    this.refreshDefaulters.next(value);
  }
}
